import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";
import { routesName } from "core";
import { UsersList } from "components/src";
import { AddUser } from "./addUser";
import { EditUser } from "./editUser";
import { UserDetail } from "./userDetail";


const Users = memo(() => {
  return (
    <Routes>
      <Route path={routesName.ADDUSER} element={<AddUser />} />
      <Route path={routesName.EDITUSER} element={<EditUser />} />
      <Route path={routesName.USERSLIST} element={<UsersList />} />
      <Route path={routesName.USERDETAIL} element={<UserDetail />} />
    </Routes>
  );
});

export { Users };
